<template>
  <div>
    <pdl-media-object v-if="hasImage" class="mb-1">
      <div slot="media" class="border border-gray-10">
        <img :qaid="`summary-list-${description}-option-${id}-image`" :src="imageReference" />
      </div>

      <div slot="content" class="flex justify-between h-full items-center">
        <div>
          <h4 :qaid="`summary-list-${description}-option-${id}-title`" class="text-sm font-bold" v-text="description" />
          <span
            :qaid="`summary-list-${description}-option-${id}-description`"
            class="text-sm"
            v-text="choice.description"
          />
        </div>

        <div>
          <span
            v-if="isHidingPrices"
            :qaid="`summary-list-${description}-option-${id}-price`"
            class="text-sm"
            v-html="bp('priceVaries')"
          />
          <span
            v-else-if="choice.dealerCost && b2b && !consumerFriendlyMode"
            :qaid="`summary-list-${description}-option-${id}-price`"
            class="text-blue text-sm"
            v-html="choice.dealerCost"
          />
          <span
            v-else-if="choice.msrp"
            :qaid="`summary-list-${description}-option-${id}-price`"
            class="text-blue text-sm"
            v-html="choice.msrp"
          />
        </div>
      </div>
    </pdl-media-object>
    <div v-else class="flex justify-between h-full items-center mb-2">
      <div>
        <h4 :qaid="`summary-list-${description}-option-${id}-title`" class="text-sm font-bold" v-text="description" />
        <span
          :qaid="`summary-list-${description}-option-${id}-description`"
          class="text-sm"
          v-text="choice.description"
        />
      </div>

      <div>
        <span
          v-if="isHidingPrices"
          :qaid="`summary-list-${description}-option-${id}-price`"
          class="text-sm"
          v-html="bp('priceVaries')"
        />
        <span
          v-else-if="choice.dealerCost && b2b && !consumerFriendlyMode"
          :qaid="`summary-list-${description}-option-${id}-price`"
          class="text-blue text-sm"
          v-html="choice.dealerCost"
        />
        <span
          v-else-if="choice.advertisedPrice"
          :qaid="`summary-list-${description}-option-${id}-price`"
          class="text-blue text-sm"
          v-html="choice.advertisedPrice"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {PdlMediaObject} from '@pedal/pdl-media-object';
import {mapState} from 'vuex';

export default {
  components: {PdlMediaObject},
  props: {
    description: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    choice: {
      type: Object,
      default: () => {},
    },
    presentationType: {
      type: String,
      default: undefined,
    },
    hasImage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    imageReference() {
      const fit = this.presentationType === 'CLR_SWATCH' ? 'stretch,1' : 'crop';
      const image =
        this.choice?.imageThumbnailReference && this.id !== this.themeGroups?.SELECTED_THEME_ID // we need to display the default image for the Theme group (ID 9)
          ? `${this.baseImageUrl}${this.choice.imageThumbnailReference}`
          : this.defaultImgUrl;

      return `${image}?wid=80&hei=60&fit=${fit}`;
    },

    ...mapState('backend', ['b2b', 'consumerFriendlyMode']),
    ...mapState('projectOne', ['baseImageUrl', 'defaultImgUrl', 'isHidingPrices', 'themeGroups']),
  },
};
</script>
